// extracted by mini-css-extract-plugin
export default {"formContainer":"InputContainer_formContainer__XDoaq"};